const tailwindConfig = require('./js/config/tailwindConfig');

module.exports = tailwindConfig();
